import { render } from "./Promo.vue?vue&type=template&id=13db3dbf&scoped=true"
import script from "./Promo.vue?vue&type=script&lang=js"
export * from "./Promo.vue?vue&type=script&lang=js"

import "./Promo.vue?vue&type=style&index=0&id=13db3dbf&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-13db3dbf"]])

export default __exports__